<template>
  <div class="autumn-course-product-list">
    <div class="title">点击下方,马上为孩子选课</div>
    <router-link class="product-item"
                 v-for="(item, index) in list"
                 :key="index"
                 :to="item.productPath"
                 :target="target"
                 v-ym-report:MARKETING_MAY_SPRING_COURSE_2020_LIST_CLICK="{ id: item.id }"
    >
      <img class="cover"
           :src="item.cover"
           :alt="item.title"
      />
      <div class="item-info">
        <div class="item-title ym-two-line-ellipsis"
             v-html="item.title"
        ></div>
        <div class="item-desc">{{ item.time }}</div>
        <div class="benefit-des">
          <span>老学员立减50元</span>
        </div>
        <div class="action-block">
          <div class="join-btn"
               v-if="item.status === 'canJoin'"
          >
            <span class="btn-text">点击报名</span>
            <img class="hand"
                 :src="require('@/pages/2020/SpringCourse/assets/img/hand.png')"
                 alt="手指"
            />
          </div>
          <div class="join-btn disabled"
               v-else
          >
            报名截止
            <img class="hand"
                 :src="require('@/pages/2020/SpringCourse/assets/img/hand.png')"
                 alt="手指"
            />
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
  import { isPC } from '@/utils';

  export default {
    name: 'AutumnCourseProductList2019',
    props: {
      list: {
        type: Array,
        required: true,
      },
      status: {
        type: String,
        required: true,
      },
    },
    computed: {
      target() {
        return isPC() ? '_blank' : '_self';
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @color-highlight: #ff7508;

  .autumn-course-product-list {
    padding: 70px 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: fade(#adeee9, 36%);
  }

  .title {
    margin-bottom: 50px;
    color: #2284b2;
    font-size: 26px;
    font-weight: @font-weight-bold;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      left: 118px;
      bottom: -32px;
      width: 0;
      height: 0;
      border-left: 24px solid transparent;
      border-right: 24px solid transparent;
      border-top: 30px solid #f4c60d;
    }
  }

  .product-item {
    width: 690px;
    padding: 20px 10px 20px 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    color: @color-text-base;
    font-size: @font-size-extra-small;
    font-weight: @font-weight-bold;
    background: @color-white;
    border-radius: 10px;
    &:not(:last-child) {
      margin-bottom: @size-medium;
    }
  }

  .cover {
    width: 274px;
    height: 206px;
    display: block;
    flex-shrink: 0;
    margin-right: 34px;
  }

  .item-info {
    align-self: stretch;
    flex: 1;
  }

  .item-title {
    margin-bottom: 16px;
    font-size: 26px;
    line-height: 1.6;
  }

  .item-desc {
    margin-bottom: 16px;
    font-weight: @font-weight-primary;
    line-height: 1.2;
  }

  .benefit-des {
    color: #f40d3e;
    font-size: 26px;
  }

  .item-hint {
    margin-bottom: 16px;
    color: @color-highlight;
    line-height: 1.2;
    &.disabled {
      color: @color-text-lighter;
      font-weight: @font-weight-primary;
    }
  }

  .action-block {
    margin-top: @size-base;
    width: 300px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 24px;
    box-sizing: border-box;
  }

  .join-price {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: #ff7508;
    border: 1px solid #ff7508;
    box-sizing: border-box;
    border-radius: 24px;
    line-height: 1;
    &.disabled {
      border-color: #eee;
      color: @color-text-lighter;
      font-weight: @font-weight-primary;
    }
  }

  .join-btn {
    width: 262px;
    height: 58px;
    border-radius: 30px;
    background: linear-gradient(90deg, #35baff, #6ce564);
    color: @color-white;
    font-weight: @font-weight-bold;
    font-size: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .hand {
      width: 40px;
      height: 28px;
      margin-left: 8px;
    }
    &.disabled {
      background: #eee;
      color: @color-text-lighter;
      font-weight: @font-weight-primary;
    }
  }

</style>
